import React from 'react';
// @ts-expect-error - TS2614 - Module '"@atlaskit/dynamic-table"' has no exported member 'RowCellType'. Did you mean to use 'import RowCellType from "@atlaskit/dynamic-table"' instead?
import type { RowCellType } from '@atlaskit/dynamic-table';
import {
	ARCHIVE_STATUS,
	DELETE_STATUS,
	DELETED_DATE,
	ARCHIVED_DATE,
} from '../../../common/constants';
import type {
	RefetchProjects,
	ProjectTransformed,
	DeletedProjects,
	ArchivedProjects,
	Status,
} from '../../../common/types';
import DateAndUserCell from './cells/date-user/index.tsx';
import ExpiryCell from './cells/expiry/index.tsx';
import TrashActionCell from './cells/trash/index.tsx';
import UnarchiveActionCell from './cells/unarchive/index.tsx';

export const getArchivedProjectsCells = (
	project: ArchivedProjects,
	refetchProjects: RefetchProjects,
): RowCellType[] => [
	{
		content: <DateAndUserCell date={project.archivedDate} user={project.archivedBy} />,
		key: ARCHIVED_DATE,
	},
	{
		content: <UnarchiveActionCell project={project} refetchProjects={refetchProjects} />,
	},
];

export const getTrashProjectsCells = (
	project: DeletedProjects,
	refetchProjects: RefetchProjects,
): RowCellType[] => [
	{
		content: <DateAndUserCell date={project.deletedDate} user={project.deletedBy} />,
		key: DELETED_DATE,
	},
	{
		content: <ExpiryCell value={project.retentionTillDate} />,
	},
	{
		content: <TrashActionCell project={project} refetchProjects={refetchProjects} />,
	},
];

export const getColumnsByStatus = (
	status: Status,
	project: ProjectTransformed,
	refetchProjects: RefetchProjects,
): RowCellType[] => {
	// @ts-expect-error - TS2339 - Property 'archivedBy' does not exist on type 'ProjectTransformed'.
	if (status === ARCHIVE_STATUS && project.archivedBy) {
		// @ts-expect-error - TS2345 - Argument of type 'ProjectTransformed' is not assignable to parameter of type 'ArchivedProjects'.
		return getArchivedProjectsCells(project, refetchProjects);
	}
	// @ts-expect-error - TS2339 - Property 'deletedBy' does not exist on type 'ProjectTransformed'.
	if (status === DELETE_STATUS && project.deletedBy) {
		// @ts-expect-error - TS2345 - Argument of type 'ProjectTransformed' is not assignable to parameter of type 'DeletedProjects'.
		return getTrashProjectsCells(project, refetchProjects);
	}
	return [];
};
